// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"4cca492b2435087a","6457":"e81304dab0bc8ab7"}[chunkId] + ".css";
};